var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('b',[_vm._v(_vm._s(_vm.label)),_c('i',{staticClass:"fa fa-asterisk fa-custom",attrs:{"aria-hidden":"true"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }